import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline-comment-dialog',
  templateUrl: './timeline-comment-dialog.component.html',
  styleUrls: ['./timeline-comment-dialog.component.scss']
})
export class TimelineCommentDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
